import { runInAction } from 'mobx';
import { temporaryBrowsingDomainStore } from '../../temporary-store/store';
export const clearCxmData = () => {
    runInAction(() => {
        temporaryBrowsingDomainStore.data.cxmFilmsForComponent = {};
    });
};
//# sourceMappingURL=clear-cxm-data.js.map